<script>
    import { Line } from 'vue-chartjs'

    export default {
        extends: Line,
        props: {
            chartdata: {},
        },
        data:function(){
            return {
                options: {
                    responsive: true,
                    maintainAspectRatio: false
                }
            }
        },
        mounted () {
            var data = JSON.parse(this.chartdata);
            var chartData = {};
            data.xData.reverse();
            data.yData.reverse();
            chartData.labels = data.xData;
            
            chartData.datasets = [{
                label: data.cn_name,
                backgroundColor: '#e5e5e5',
                data: data.yData,
            }];
            this.renderChart(chartData, this.options);
        }
    }
</script>
